// Perguntas frequentes da home (também viram marcação FAQPage para o Google).
// Texto informativo: revisado pelos advogados antes de publicar.

export const FAQ = [
  {
    q: 'Sou obrigado a falar na delegacia?',
    a: 'Não. A Constituição garante o direito de permanecer em silêncio, e o silêncio não pode ser usado contra você. Também é seu direito ser acompanhado por advogado durante o depoimento.'
  },
  {
    q: 'Qual a diferença entre inquérito policial e ação penal?',
    a: 'O inquérito é a investigação conduzida pela polícia. A ação penal é o processo na Justiça, que começa quando o Ministério Público oferece a denúncia e o juiz a recebe.'
  },
  {
    q: 'O que é a audiência de custódia?',
    a: 'Em até 24 horas após a prisão, a pessoa é apresentada a um juiz. Ele verifica se a prisão foi legal e decide se ela será relaxada, se cabe liberdade provisória ou se a prisão será mantida.'
  },
  {
    q: 'O atendimento é sigiloso?',
    a: 'Sim. Tudo o que você relata ao advogado é protegido pelo sigilo profissional, previsto no Estatuto da Advocacia e no Código de Ética da OAB.'
  },
  {
    q: 'O escritório atende casos de outras cidades?',
    a: 'Sim. O escritório atua na Justiça Estadual e Federal e nos tribunais superiores, e o processo eletrônico permite acompanhar casos de outras comarcas. A viabilidade é avaliada caso a caso.'
  },
  {
    q: 'Como são definidos os honorários?',
    a: 'Dependem da complexidade e da fase do caso. O valor é informado depois da análise da situação, em contrato escrito, observando a tabela de honorários da OAB/PR.'
  }
];
